module.exports = __webpack_public_path__ + "img/Frank-frazetta_Green_Death.3e455ef9.jpg";